<template>
  <main class="home row soporte-list">
    <header v-if="$route.meta.hasHeader">
      <img
        src="../assets/images/banners/soporte_interno_mobile.svg"
        class="banner-soporte--mobile"
        alt=""
      />
      <img
        src="../assets/images/banners/soporte_interno_mobile.svg"
        class="banner-soporte inverse"
        alt=""
      />
      <h2>{{ title }}</h2>
      <img
        src="../assets/images/banners/soporte_interno_mobile.svg"
        alt=""
        class="banner-soporte"
      />
    </header>
    <article class="soporte-list__content columns is-desktop">
      <aside class="column is-one-quarter-desktop">
        <div class="back-button" v-if="$route.name == 'soporte-article'">
          <a @click="$router.go(-1)">
            <svg
              width="46"
              height="64"
              viewBox="0 0 46 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.6947 63.4901C43.3839 63.9498 44.3153 63.7637 44.775 63.0745C45.2346 62.3853 45.0486 61.454 44.3594 60.9943L42.6947 63.4901ZM2.94243 35.1737L3.77474 33.9258V33.9258L2.94243 35.1737ZM2.89822 30.2122L2.0438 28.9793H2.0438L2.89822 30.2122ZM44.3815 3.28809C45.0624 2.81621 45.2318 1.8817 44.7599 1.2008C44.288 0.519905 43.3535 0.350464 42.6726 0.822346L44.3815 3.28809ZM44.3594 60.9943L3.77474 33.9258L2.11013 36.4216L42.6947 63.4901L44.3594 60.9943ZM3.75263 31.4451L44.3815 3.28809L42.6726 0.822346L2.0438 28.9793L3.75263 31.4451ZM3.77474 33.9258C2.894 33.3384 2.88249 32.0481 3.75264 31.4451L2.0438 28.9793C-0.566587 30.7884 -0.532113 34.6594 2.11013 36.4216L3.77474 33.9258Z"
                fill="#1FB3AC"
              />
            </svg>
            <span>Back</span>
          </a>
        </div>
        <h6 class="is-hidden-touch">Categorías</h6>
        <div class="field">
          <p class="control has-icons-right">
            <input
              class="input is-rounded is-hovered is-medium"
              type="text"
              placeholder="Tipea aquí..."
            />
            <span class="icon is-small is-right">
              <i class="fas fa-search"></i>
            </span>
          </p>
        </div>
        <div class="field field-aux is-hidden-desktop">
          <p @click="openSoporteBar">
            Categorías <span>{{ isBarOpen ? "-" : "+" }}</span>
          </p>
          <div class="bar-cat" v-show="isBarOpen">
            <details
              v-for="mod in modules"
              :key="`as-${mod.id}`"
              :open="isOpen(mod.slug)"
            >
              <summary>{{ mod.name }}</summary>
              <ul>
                <li
                  v-for="sub in mod.submodules"
                  :key="`submod-${sub.name}-mod-${mod.name}`"
                >
                  <a @click="toLink(mod.slug)">{{ sub.name }}</a>
                </li>
              </ul>
            </details>
          </div>
        </div>
        <div class="sidebar-wrap is-hidden-touch">
          <details
            v-for="mod in modules"
            :key="`as-${mod.id}`"
            :id="`toogle-sidebar-wide-${mod.name}`"
            :open="isOpen(mod.slug)"
            @click.prevent="toLink(mod.slug, `toogle-sidebar-wide-${mod.name}`)"
          >
            <summary>{{ mod.name }}</summary>
            <ul>
              <li
                v-for="sub in mod.submodules"
                :key="`submod-${sub.name}-mod-${mod.name}`"
                :class="{ 'submodule-active': $route.hash === `#${sub.slug}` }"
              >
                <a
                  @click.stop="
                    toLink(
                      mod.slug,
                      `toogle-sidebar-wide-${mod.name}`,
                      sub.slug
                    )
                  "
                  >{{ sub.name }}</a
                >
              </li>
            </ul>
          </details>
          <span>
            Ver todo
          </span>
        </div>
      </aside>
      <section class="soporte-cotent column column-75">
        <router-view name="soporte"></router-view>
      </section>
    </article>
    <article class="article-wrap-uax column is-offset-one-quarter-desktop">
      <section class="section section-more-categories columns">
        <div class="column more-categories-content">
          <h3>Más categorías</h3>
          <div class="categories">
            <ul class="columns">
              <div class="column">
                <li
                  class="featured-module-item"
                  v-for="featMod in featuredModuleOne"
                  :key="`feature-module-${featMod.slug}`"
                  @click="featureLink(featMod)"
                >
                  {{ featMod.name }}
                </li>
              </div>
              <div class="column">
                <li
                  class="featured-module-item"
                  v-for="featMod in featuredModuleTwo"
                  :key="`feature-module-${featMod.slug}`"
                  @click="featureLink(featMod)"
                >
                  {{ featMod.name }}
                </li>
              </div>
            </ul>
          </div>
        </div>
      </section>
    </article>
  </main>
</template>

<script>
// import Article from '../components/soporte/Article.vue';
export default {
  name: "SoporteList",
  data() {
    return {
      isBarOpen: false,
      featuredModulePivot: 6
    };
  },
  computed: {
    modules() {
      return this.$store.getters.modulesGetter;
    },
    title() {
      return this.$store.getters.actualModuleGetter.name;
    },
    featuredModules() {
      return this.$store.getters.modulesFeaturedGetter;
    },
    limit() {
      return this.featuredModulePivot > this.featuredModules.length / 2
        ? this.featuredModulePivot
        : Math.ceil(this.featuredModules.length / 2);
    },
    featuredModuleOne() {
      return this.featuredModules.slice(0, this.limit);
    },
    featuredModuleTwo() {
      return this.featuredModules.slice(this.limit);
    }
  },
  async beforeCreate() {
    this.$modal.show("loader-root");
    await this.$store.dispatch("getModules");
    if (this.$route.params.id) {
      await this.$store.dispatch("getModuleDetail", {
        slug: this.$route.params.id
      });
      if (this.$route.hash) {
        console.log("window.offsetY ", window.pageYOffset);
        window.scrollTo(0, window.pageYOffset - 150);
      }
    }
    this.$modal.hide("loader-root");
  },
  methods: {
    isOpen(mod) {
      return (
        mod === String(this.$route.params.id) ||
        mod === this.$store.getters.actualModuleGetter.slug
      );
    },
    toLink(val, id = null, sub = null) {
      console.log(val);
      // let namePath = val.toLowerCase();
      if (!sub) {
        if (val !== this.$route.params.id) {
          this.$router.push({ name: "soporte-list", params: { id: val } });
        }
      } else {
        if (sub !== this.$route.params.id) {
          this.$router.push({
            name: "soporte-list",
            params: { id: val },
            hash: `#${sub}`
          });
        }
      }

      if (!id) {
        this.isBarOpen = false;
      }
      if (id) {
        let el = document.getElementById(id);
        el.toggleAttribute("open", true);
      }
    },
    openSoporteBar() {
      if (!this.isBarOpen) {
        this.isBarOpen = true;
      } else {
        this.isBarOpen = false;
      }
    },
    featureLink(val) {
      console.log(val);
      if (val.isMain) {
        this.$router.push({ name: "soporte-list", params: { id: val.slug } });
      } else {
        let parent = this.getParent(val.slug);
        if (parent) {
          this.$router.push({
            name: "soporte-list",
            params: { id: parent.slug },
            hash: `#${val.slug}`
          });
        }
      }
    },
    getParent(slugChild) {
      console.log(slugChild);
      console.log(this.$store.getters.modulesGetter);
      return this.$store.getters.modulesGetter
        .filter(mod => mod.submodules.length > 0)
        .find(modu => modu.submodules.find(sub => sub.slug === slugChild));
    }
  },
  watch: {
    $route: async function(n) {
      this.$modal.show("loader-root");
      if (n.params.id) {
        await this.$store.dispatch("getModuleDetail", { slug: n.params.id });
      }
      if (n.hash) {
        console.log("window.offsetY ", window.pageYOffset);
        window.scrollTo(0, window.pageYOffset - 150);
      }
      this.$modal.hide("loader-root");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/general";
.soporte-list {
  header {
    height: 300px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-end;
    align-items: center;
    // background-image: url("../assets/images/banners/soporte_interno_mobile.svg");
    // background-size: contain;
    // background-repeat: no-repeat;
    // background-position: top;
    h2 {
      font-weight: bold;
      font-size: 2rem;
      margin: 1.5em auto 1em;
    }
    @include tablet() {
      height: 250px;
      background-image: none;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      h2 {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1em auto;
      }
      img {
        width: 30%;
        height: auto;
        flex-shrink: 1;
        &.inverse {
          transform: rotateY(180deg);
        }
      }
    }
    @include laptop() {
      height: 250px;
      background-image: none;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      h2 {
        font-weight: bold;
        font-size: 2rem;
        margin: 1em auto;
      }
      img {
        width: 30%;
        height: auto;
        flex-shrink: 1;
        &.inverse {
          transform: rotateY(180deg);
        }
      }
    }
  }
  &__content {
    padding: 1rem 0 0;
    width: 100%;
    margin: 0em auto 0;
    aside {
      text-align: start;
      @media (max-width: 650px) {
        min-width: 100%;
        width: 100%;
      }
      .field {
        @include laptop() {
          max-width: 300px;
        }
      }
      .control {
        .input {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          height: 1.5em;
          &::placeholder {
            font-weight: bold;
            color: #ababab;
          }
        }
        &.has-icons-right {
          .icon {
            height: 1.5em !important;
          }
        }
      }

      h6 {
        font-weight: bold;
        font-size: 2.3rem;
        letter-spacing: 0.05em;
        margin-bottom: 1.5em;
      }
      .sidebar-wrap {
        padding: 1rem;
        details {
          margin: 1rem 0;
          font-size: 1.2rem;
          summary {
            font-weight: bold;
            cursor: pointer;
            &::-webkit-details-marker {
              display: none;
            }
            &:focus,
            &:active {
              outline: none;
            }
          }
          ul {
            list-style: none;
            font-size: 1rem;
            padding-left: 1.5rem;
            color: #ababab;
            font-weight: bold;
            margin: 0.8rem 0 !important;
            li {
              margin: 0px !important;
              cursor: pointer;
              a {
                color: #6d6e70;
                &:hover {
                  color: #1fb3ac;
                }
              }
            }
          }
        }
      }
    }
    @include laptop() {
      margin: 4em auto;
      padding: 1rem 0;
    }
  }
  .soporte-cotent {
    @media (max-width: 650px) {
      min-width: 100%;
      width: 100%;
    }
  }
}
.back-button {
  margin-left: -2rem;
  a {
    color: #1fb3ac;
    cursor: pointer;
    text-decoration: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    font-weight: bold;
  }
  svg {
    transform: scale(0.3) translateX(35px);
  }
}
.field-aux {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  margin: 1.5rem 0;
  p {
    font-weight: bold;
    span {
      color: $primary;
    }
  }
  .bar-cat {
    position: absolute;
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0px rgba($color: #666666, $alpha: 0.5);
    padding: 0.5em 1em;
    border-radius: 20px;
    z-index: 9;
    top: 25px;
    right: -5px;
    summary::-webkit-details-marker {
      display: none;
    }

    summary:after {
      float: right;
      height: 20px;
      width: 20px;
      content: "+";
      font-size: 15px;
      color: #1fb3ac;
      font-weight: bold;
    }
    details[open] summary:after {
      content: "-";
      float: right;
      color: #1fb3ac;
    }
    details {
      font-size: 14px;
      text-align: end;
      margin-bottom: 1em;
      summary {
        font-weight: bold;
        &:focus {
          outline: none;
        }
      }
      ul {
        margin: 10px 0;
        li {
          a {
            font-size: 14px;
            color: #666666;
            padding-right: 1.2em;
          }
        }
      }
    }
  }
}
.section-more-categories {
  background-color: #eafffe;
  padding: 1rem 0 2rem;
  // padding-top: 1rem;
  margin: 0px;
  .more-categories-content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0px;
  }
  h3 {
    text-align: start;
    font-weight: bold;
    font-size: 1.2rem;
    letter-spacing: 0.1em;
    margin: 1em auto;
    width: 80%;
  }
  .categories {
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: flex-start;
    width: 80%;
    margin: 1rem auto;
    .column {
      display: block;
      flex-basis: 0;
      flex-grow: 1;
      flex-shrink: 1;
      padding: 0;
    }
    ul {
      width: 100%;
      text-align: start;
      font-weight: bold;
      font-size: 0.9rem;
      list-style: none; /* Remove default bullets */
      margin-left: 1.5rem;
      .featured-module-item {
        cursor: pointer;
      }
      // margin-top: 1rem;
      li {
        margin: 0.8rem 0;
      }
    }

    ul li::before {
      content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
      color: #058b87; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
  }
  @include tablet() {
    h3 {
      font-size: 1.8rem;
    }
    .categories {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;
      ul {
        font-size: 1.2rem;
      }
    }
  }
  @include laptop() {
    padding: 2rem 3rem;
    margin-bottom: 3rem;
    h3 {
      font-size: 2.5rem;
      margin-bottom: 3rem;
      width: 100%;
    }
    .categories {
      width: 100%;
      margin: 3rem auto;
      .column {
        padding: 0.75rem;
      }
      ul {
        list-style: disc;
        margin-left: 2rem;
        li {
          margin-bottom: 1rem;
        }
      }
    }
  }
}
.article-wrap-uax {
  padding: 0px !important;
  @include laptop() {
    margin-bottom: 8rem;
  }
}
.banner-soporte {
  display: none;
  @include tablet() {
    display: block;
  }
  @include laptop() {
    display: block;
  }
}
.banner-soporte--mobile {
  display: block;
  @include tablet() {
    display: none;
  }
  @include laptop() {
    display: none;
  }
}
.submodule-active {
  a {
    color: $primary !important;
  }
}
</style>
